<template>
  <v-content class="gb">
    <div class="back-container" style="max-width: 1222px !important; margin: 0 auto;">
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <div class="custom-position-back">
            <v-btn rounded depressed class="back-btn" @click="$router.push('/owner/users')">
              <img :src="require('@/assets/img/back.svg')" class="mr-2"/>
              back
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-container class="fill-width" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <v-card :loading="status === 'loading'" class="fill-width card-theme owner-add-users">
            <v-row align="center" class="flex-colum px-8">
              <v-col lg4 xs12 style="padding: 0!important;">
                <h2 class="azul medium-font main-title">Add New Agent</h2>
              </v-col>
              <v-col lg8 xs12 style="text-align: end;">
                <v-btn
                    rounded
                    depressed
                    class="px-4 ml-4 btn-blanco btn-blanco--a btn-white-add"
                    style="text-transform: capitalize; font-size: 12px;"
                    @click="downloadTemplate"
                >
                  <v-icon x-small class="mr-1">fa-download</v-icon>
                  Download Template
                </v-btn>
                <v-btn
                    rounded
                    depressed
                    class="px-4 ml-4 btn-blanco btn-blanco--a btn-white-add"
                    style="text-transform: capitalize; font-size: 12px;"
                    @click="$refs.fileInput.click()"
                >
                  <v-icon x-small class="mr-1">fa-upload</v-icon>
                  Upload CSV/Excel
                </v-btn>
                <input
                    ref="fileInput"
                    type="file"
                    accept=".csv,.xlsx,.xls"
                    style="display: none;"
                    @change="handleFileUpload"
                />
                <v-btn
                    rounded
                    depressed
                    class="px-6 ml-2 btn-blanco btn-blanco--a btn-white-add"
                    style="text-transform: capitalize;"
                    @click="addNewUsers"
                >+ Add New Agent
                </v-btn>
              </v-col>
            </v-row>

            <!-- Upload status summary (plain text, not banners) -->
            <div v-if="uploadSummary || issuesList.length > 0" class="px-8 mt-3">
              <div v-if="uploadSummary" style="font-size: 13px; color: #7a7a7a;">
                {{ uploadSummary }}<span v-if="issuesList.length > 0"> — {{ issuesList.length }} issue{{ issuesList.length !== 1 ? 's' : '' }} to fix</span>
              </div>
              <div v-if="parseError" style="font-size: 13px; color: #d32f2f; margin-top: 4px;">
                {{ parseError }}
              </div>
              <ul v-if="issuesList.length > 0" class="upload-issues-list">
                <li v-for="(issue, idx) in issuesList" :key="idx">{{ issue }}</li>
              </ul>
            </div>

            <ValidationObserver ref="validator" v-slot="{}">
              <div class="agent-entries px-4 mt-6">
                <div v-for="(item, index) in users" :key="index" class="agent-entry">
                  <div class="agent-fields">
                    <v-row>
                      <v-col cols="5">
                        <ValidationProvider
                            ref="firstName"
                            mode="lazy"
                            rules="required"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.first_name"
                              :error-messages="errors"
                              label="First Name"
                              name="firstName"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="7">
                        <ValidationProvider
                            ref="lastName"
                            mode="lazy"
                            rules="required"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.last_name"
                              :error-messages="errors"
                              label="Last Name"
                              name="lastName"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="5">
                        <ValidationProvider
                            ref="email"
                            mode="lazy"
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.email"
                              :error-messages="errors"
                              label="Email"
                              name="email"
                              type="text"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="4">
                        <ValidationProvider
                            ref="phone"
                            mode="lazy"
                            rules="required|size:10"
                            v-slot="{ errors }"
                        >
                          <v-text-field
                              v-model="item.phone_number"
                              :error-messages="item.phone_error ? [item.phone_error] : errors"
                              label="Cell Phone"
                              name="phone"
                              type="text"
                              v-mask="mask"
                              required
                              class="ui-label change_bord especial_border custom-input-position-text label-medium"
                              @input="clearPhoneError(item)"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="3">
                        <div style="display: flex; flex-direction: column; align-items: center; padding-top: 2px;">
                          <div style="display: flex; align-items: center;">
                            <span style="font-size: 16px; font-weight: bold; color: #061d47;">Admin Access</span>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span v-on="on" style="margin-left: 6px; display: inline-flex;">
                                  <img
                                      :src="require('@/assets/info.png')"
                                      alt="help"
                                      class="info-tooltip"
                                  />
                                </span>
                              </template>
                              <span>
                                Admin Panel access will allow the agent to
                                <br/>manage billing information, add/remove
                                <br/>agents & vendors, view reports and manage
                                <br/>the account.
                              </span>
                            </v-tooltip>
                          </div>
                          <v-checkbox
                              v-model="item.is_admin"
                              hide-details
                              style="margin: 4px 0 0 0; padding: 0;"
                          ></v-checkbox>
                        </div>
                      </v-col>
                    </v-row>
                    <v-alert v-if="item.error" border="top" color="red lighten-2" dark>{{ item.error }}</v-alert>
                  </div>
                  <div class="agent-remove">
                    <span @click="removeItem(item)" class="remove-data">
                      <img :src="require('@/assets/img/close_red.svg')"/>
                    </span>
                  </div>
                </div>
              </div>

              <v-card-text class="px-5 remove-paddings" style="padding-top: 0 !important;">
                <div class="pl-7">
                  <!-- Progress bar during submission -->
                  <div v-if="status === 'loading' && submitTotal > 0" class="mb-4">
                    <div style="font-size: 14px; color: #061d47; margin-bottom: 8px;">
                      Submitting {{ submitProgress }} of {{ submitTotal }} agents...
                    </div>
                    <v-progress-linear
                        :value="(submitProgress / submitTotal) * 100"
                        color="#29abe2"
                        height="8"
                        rounded
                    ></v-progress-linear>
                  </div>

                  <ValidationProvider
                      name="agree_terms"
                      ref="agree_terms"
                      rules="required-check"
                      v-slot="{ errors }"
                  >
                    <v-checkbox
                        v-model="agree_terms"
                        :error-messages="errors"
                        class="label-checkbox-vendor custom-check-box c-check"
                    >
                      <div slot="label" class="terms-privacy-agreement" style="color: #061d47;">
                        I understand that upon clicking submit, the users listed above will
                        receive email and text notifications granting them access to sign up
                        under my account.
                      </div>
                    </v-checkbox>
                  </ValidationProvider>
                  <div class="text-center mt-12">
                    <v-btn
                        depressed
                        rounded
                        class="ml-6 btn-azul"
                        :loading="status === 'loading'"
                        :disabled="status === 'loading' || hasBlockingErrors"
                        @click="submit"
                        style="margin: 0px auto 0px !important;"
                    >ACCEPT
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
      <declined-modal :show="showDeclinedModal" :hide="hideDeclinedModal"/>
      <success-modal :show="showSuccessModal" :hide="hideSuccessModal"/>
    </v-container>
  </v-content>
</template>


<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import declinedModal from "./modals/declined";
  import successModal from "./modals/success";
  import {mask} from "vue-the-mask";
  import {mapState} from "vuex";
  import ExcelJS from "exceljs";

  export default {
    name: "AddUsers",
    created() {
      this.$store.dispatch("Banner/show");
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        this.addNewUsers();
      } else {
        this.$router.push("/owner/sign_up");
      }
    },
    directives: {
      mask,
    },
    data() {
      return {
        agree_terms: false,
        mask: "### - ### - ####",
        showDeclinedModal: false,
        showSuccessModal: false,
        users: [],
        coupon_code: "",
        uploadSummary: "",
        parseError: "",
      };
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      "declined-modal": declinedModal,
      "success-modal": successModal,
    },
    computed: {
      ...mapState({
        status: (state) => state.Owner_users_add_user.status,
        user: (state) => state.Authenticate.user,
        submitProgress: (state) => state.Owner_users_add_user.submitProgress,
        submitTotal: (state) => state.Owner_users_add_user.submitTotal,
      }),
      hasBlockingErrors() {
        if (this.parseError) return true;
        return this.users.some(u => u.phone_error);
      },
      issuesList() {
        const issues = [];
        this.users.forEach((u, i) => {
          const row = i + 1;
          if (u.phone_error) issues.push(`Row ${row}: ${u.phone_error}`);
        });
        return issues;
      },
    },
    methods: {
      addNewUsers: function () {
        this.users.push({
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          is_admin: false,
        });
      },
      clearPhoneError(item) {
        this.$set(item, 'phone_error', '');
      },
      async submit() {
        const self = this;
        const valid = await this.$refs.validator.validate();
        if (valid) {
          self.$store
            .dispatch("Owner_users_add_user/add_users", self.users)
            .then(async (errorsCounter) => {
              if (errorsCounter === 0) {
                await self.$store.dispatch("Users_list/clear_data", true);
                self.show_SuccessModal();
              } else {
                await this.$refs.validator.validate();
                for (let i = 0; i < self.users.length; i++) {
                  if (self.users[i].error === '') {
                    self.users.splice(i, 1);
                  }
                }
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      },
      show_DeclinedModal() {
        this.showDeclinedModal = true;
      },
      hideDeclinedModal() {
        this.showDeclinedModal = false;
      },
      show_SuccessModal() {
        this.showSuccessModal = true;
      },
      hideSuccessModal() {
        this.showSuccessModal = false;
      },
      removeItem(a) {
        this.users.splice(this.users.indexOf(a), 1);
      },
      downloadTemplate() {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('Agents');
        sheet.columns = [
          { header: 'First Name', key: 'first_name', width: 20 },
          { header: 'Last Name', key: 'last_name', width: 20 },
          { header: 'Email', key: 'email', width: 30 },
          { header: 'Phone Number', key: 'phone_number', width: 20 },
          { header: 'Admin Access', key: 'is_admin', width: 15 },
        ];
        sheet.getRow(1).font = { bold: true };
        sheet.addRow({
          first_name: 'John',
          last_name: 'Doe',
          email: 'john@example.com',
          phone_number: '5551234567',
          is_admin: 'No',
        });
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'agent_upload_template.xlsx';
          a.click();
          URL.revokeObjectURL(url);
        });
      },
      async handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        this.$refs.fileInput.value = '';

        this.uploadSummary = '';
        this.parseError = '';

        try {
          const workbook = new ExcelJS.Workbook();
          const buffer = await file.arrayBuffer();

          if (file.name.endsWith('.csv')) {
            await workbook.csv.load(buffer);
          } else {
            await workbook.xlsx.load(buffer);
          }

          const sheet = workbook.worksheets[0];
          if (!sheet) {
            this.parseError = 'No worksheet found in file.';
            return;
          }

          // Map header names to our fields
          const headerMap = {};
          const headerRow = sheet.getRow(1);
          headerRow.eachCell((cell, colNumber) => {
            const val = String(cell.value || '').trim().toLowerCase();
            if (val.includes('first') && val.includes('name')) headerMap[colNumber] = 'first_name';
            else if (val.includes('last') && val.includes('name')) headerMap[colNumber] = 'last_name';
            else if (val.includes('email')) headerMap[colNumber] = 'email';
            else if (val.includes('phone') || val.includes('cell') || val.includes('mobile')) headerMap[colNumber] = 'phone_number';
            else if (val.includes('admin')) headerMap[colNumber] = 'is_admin';
          });

          const requiredFields = ['first_name', 'last_name', 'email', 'phone_number'];
          const mappedFields = Object.values(headerMap);
          const missingFields = requiredFields.filter(f => !mappedFields.includes(f));
          if (missingFields.length > 0) {
            this.parseError = 'Your file is missing some required columns. Please download the template and make sure it includes: First Name, Last Name, Email, and Phone Number.';
            return;
          }

          const parsedUsers = [];
          const phonesSeen = {};

          sheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) return;

            const entry = {
              first_name: '',
              last_name: '',
              email: '',
              phone_number: '',
              is_admin: false,
              phone_error: '',
            };

            row.eachCell((cell, colNumber) => {
              const field = headerMap[colNumber];
              if (!field) return;
              let val = cell.value;
              if (val && typeof val === 'object' && val.richText) {
                val = val.richText.map(r => r.text).join('');
              }
              if (val && typeof val === 'object' && val.text) {
                val = val.text;
              }
              val = String(val || '').trim();

              if (field === 'is_admin') {
                entry.is_admin = ['yes', 'true', '1', 'y'].includes(val.toLowerCase());
              } else if (field === 'phone_number') {
                let digits = val.replace(/\D/g, '');
                if (digits.length === 11 && digits.startsWith('1')) {
                  digits = digits.substring(1);
                }
                if (digits.length === 10) {
                  entry.phone_number = digits.substring(0, 3) + ' - ' + digits.substring(3, 6) + ' - ' + digits.substring(6);
                } else if (digits.length > 0) {
                  entry.phone_number = val;
                  entry.phone_error = 'Phone number must be 10 digits';
                }
              } else {
                entry[field] = val;
              }
            });

            // Skip completely empty rows
            if (!entry.first_name && !entry.last_name && !entry.email && !entry.phone_number) return;

            // Check for duplicate phones
            const cleanPhone = entry.phone_number.replace(/\D/g, '');
            if (cleanPhone && phonesSeen[cleanPhone]) {
              entry.phone_error = 'Duplicate phone number';
            }
            phonesSeen[cleanPhone] = true;

            parsedUsers.push(entry);
          });

          if (parsedUsers.length === 0) {
            this.parseError = 'No data rows found in file.';
            return;
          }

          this.users = parsedUsers;
          this.uploadSummary = `${parsedUsers.length} agent${parsedUsers.length !== 1 ? 's' : ''} loaded from ${file.name}`;
        } catch (err) {
          console.error('File parse error:', err);
          this.parseError = 'Unable to read this file. Please download the template and ensure your file is saved as .csv or .xlsx before uploading.';
        }
      },
    },
  };
</script>
<style scoped>
  .additional-info {
    background-color: #fbfbfb;
  }

  .additional-info span.label {
    color: #061d47 !important;
    font-size: 17px !important;
    font-weight: bold !important;
  }

  .data-info {
    width: 24%;
  }

  .alert-value-font {
    color: #4565ab;
    font-size: 18px;
  }

  .upload-issues-list {
    margin: 4px 0 0 0;
    padding-left: 18px;
    list-style: none;
  }

  .upload-issues-list li {
    font-size: 12px;
    color: #d32f2f;
    line-height: 1.6;
  }

  .upload-issues-list li::before {
    content: "\2022";
    color: #d32f2f;
    display: inline-block;
    width: 12px;
    margin-left: -12px;
  }

  @media (max-width: 1024px) {
    .app-grid-users {
      margin-top: 3px !important;
      display: flex;
      width: 100% !important;
      margin-left: 0px;
      justify-content: space-between;
    }

    .app-grid-users .label-tooltip {
      padding-top: 7px;
      text-align: left;
      width: 200px !important;
    }
  }

  .agent-entry {
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
  }

  .agent-entry + .agent-entry {
    border-top: 2px solid #061d47;
  }

  .agent-fields {
    flex: 1;
    min-width: 0;
  }

  .agent-remove {
    display: flex;
    align-items: center;
    padding-left: 16px;
  }

  @media (min-width: 960px) {
    .ct-admin {
      position: relative;
      top: -10px;
    }
  }

  @media (max-width: 960px) {
    .data-info {
      width: 100%;
    }
  }

  @media (max-width: 690px) {
    .app-grid-users {
      width: 100% !important;
    }
  }
</style>
<style>
  .owner-add-users .agent-fields .v-text-field input {
    padding-top: 12px !important;
  }
</style>
